//#region lib/Table/lib/consumes.ts
var e = ({ input: e }) => {
	let { type: t, data: n } = e;
	return typeof n == "string" && ["core/table"].includes(t) ? [!0, "core/table"] : [!1];
};
//#endregion
export { e as consumes };
